import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ProposalEffects, proposalReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([ProposalEffects]), StoreModule.forFeature(`proposal`, proposalReducer)]
})
export class ProposalStateModule {}
